import React, { useContext } from "react";
import { RootContext } from "../../contexts/root-context.js";
import ConfigureSLD from "./configure-sld.js";
import WNTNavBar from '../../components/Wide-Area-Network-Twin-Components/WNT-Navbar/wnt-navbar.js';
import Navbar from '../../components/Navbar/navbar.js';

function WNTDashboard() {
  const { showConfigureSLDPage } = useContext(RootContext);
  return (
    <>
      <Navbar />
      {showConfigureSLDPage ? <ConfigureSLD /> : <WNTNavBar />}
    </>
  );
}

export default WNTDashboard;
